<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>
		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="4">
							<a-form-item label="类型">
								<a-select v-model="queryParams.callType" placeholder="请选择" default-value="">
									<a-select-option value="VILTE">视频</a-select-option>
									<a-select-option value="VOLTE">语音</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="通话">
								<a-select v-model="queryParams.isConnect" placeholder="请选择" default-value="">
									<a-select-option value="Y">已接通</a-select-option>
									<a-select-option value="N">未接通</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="结算">
								<a-select v-model="queryParams.isSettle" placeholder="请选择" default-value="">
									<a-select-option value="Y">已结算</a-select-option>
									<a-select-option value="N">待结算</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						
						<template v-if="advanced">
							<a-col :span="4">
								<a-form-item label="主叫">
									<a-input v-model="queryParams.caller" placeholder="id/昵称" />
								</a-form-item>
							</a-col>
							<a-col :span="4">
								<a-form-item label="被叫">
									<a-input v-model="queryParams.called" placeholder="id/昵称" />
								</a-form-item>
							</a-col>
							<a-col :span="4">
							<a-form-item label="录音">
								<a-select v-model="queryParams.isTape" placeholder="请选择" default-value="">
									<a-select-option value="Y">有</a-select-option>
									<a-select-option value="N">无</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
							<a-col :md="8">
								<a-form-item label="时间">
									<a-range-picker @change="onCreateTime" v-model="createTime" style="width:100%" />
								</a-form-item>
							</a-col>
						</template>
						<a-col :span="!advanced && 4 || 24">
							<span class="x-filter-submit-box"
								:style="advanced && {float:'right', overflow:'hidden'} || {}">
								<a-button type="primary" @click="fetchTableData">查询</a-button>
								<a-button style="margin-left:8px" @click="rest()">重置</a-button>
								<a @click="toggleAdvanced" style="margin-left: 8px">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
						</a-col>
					</a-row>
				</a-form>
			</div>

			<a-table :rowKey="record => record.id" :columns="tableColumns" :loading="tableLoading"
				:dataSource="tableData" :pagination="false">
				<template slot="caller" slot-scope="record">
					<div class="user" v-if="record.caller && record.caller.id">
						<div class="user-left">
							<img class="cover-img" :src="record.caller.avatarUrl || ''" width="48" height="48" alt="" />
						</div>
						<div class="user-right">
							<p class="first">
								<span class="nickname">{{ record.caller.nickname }}</span>
							</p>
							<p class="row">
								<span class="user-right-detail" v-if="record.caller.sex === 'MALE'">男</span>
								<span class="user-right-detail" v-else-if="record.caller.sex === 'FEMALE'">女</span>
								<span class="user-right-detail" v-if="record.caller.age != null && record.caller.age !== ''">{{ record.caller.age }}岁</span>
								<span class="user-right-detail">{{ record.caller.province }}{{ record.caller.city }}</span>
							</p>
						</div>
					</div>
					<span v-else class="user-empty">-</span>
				</template>

				<template slot="called" slot-scope="record">
					<div class="user" v-if="record.called && record.called.id">
						<div class="user-left">
							<img class="cover-img" :src="record.called.avatarUrl || ''" width="48" height="48" alt="" />
						</div>
						<div class="user-right">
							<p class="first">
								<span class="nickname">{{ record.called.nickname }}</span>
							</p>
							<p class="row">
								<span class="user-right-detail" v-if="record.called.sex === 'MALE'">男</span>
								<span class="user-right-detail" v-else-if="record.called.sex === 'FEMALE'">女</span>
								<span class="user-right-detail" v-if="record.called.age != null && record.called.age !== ''">{{ record.called.age }}岁</span>
								<span class="user-right-detail">{{ record.called.province }}{{ record.called.city }}</span>
							</p>
						</div>
					</div>
					<span v-else class="user-empty">-</span>
				</template>

				<template slot="type" slot-scope="record">
					<div>
						<span v-if="record.callType=='VILTE'">视频</span>
						<span v-else>语音</span>
					</div>
				</template>

				<template slot="chat" slot-scope="record">
					<div class="complex">
                        <span v-if="record.status == 'INVITE'" class="processing">呼叫中</span>
                        <span v-else-if="record.status == 'CALLING'" class="processing">正在通话</span>
                        <div v-else>
                            <div v-if="record.isConnect=='Y'">
                                <span>通话结束</span>
								<p class="depict" v-if="record.callLen">{{record.callLen}}</p>
							</div>
                            <div v-else>
                                <span class="error">未接通</span>
                            </div>
                        </div>
                        <p class="depict" v-if="record.hangup==1">被叫拒绝</p>
                        <p class="depict" v-else-if="record.hangup==2">被叫未接听</p>
                        <p class="depict" v-else-if="record.hangup==3">主叫取消</p>
                        <p class="depict" v-else-if="record.hangup==4">支出方金币不足挂断</p>
                        <p class="depict" v-else-if="record.hangup==5">违规中断</p>
					</div>
				</template>

                <template slot="bill" slot-scope="record">
                    <span v-if="record.billMinutes > 0">{{ record.billMinutes }}分钟</span>
                    <span v-else>-</span>
                </template>

				<template slot="expend" slot-scope="record">
					<div class="complex" v-if="record.userExpend > 0">
                        <span>{{ record.userExpend }}金币</span>
                        <p class="depict">{{ record.expendUserNickname }}</p>
					</div>
                    <span v-else>-</span>
				</template>

                <template slot="income" slot-scope="record">
                    <div class="complex" v-if="record.userIncome > 0">
                        <span>{{ record.userIncome }}积分<label class="rate"> - {{ record.profitRate }}</label></span>
                        <p class="depict">{{ record.incomeUserNickname }}</p>
                    </div>
                    <span v-else>-</span>
                </template>

                <template slot="violation" slot-scope="record">
                    <span v-if="record.isViolation == 'Y'" class="error">违规</span>
                    <span v-else>正常</span>
                </template>

                <template slot="settle" slot-scope="record">
                    <div class="complex">
                        <div v-if="record.isSettle == 'Y'">
                            <span>已结算</span>
                            <p class="depict">{{ record.settleTime }}</p>
                        </div>
                        <span v-else class="warning">未结算</span>
                    </div>
                </template>

                <template slot="action">
                    <a>详情</a>
                </template>

			</a-table>

			<div class="x-pagination">
				<a-pagination :pageSize="pageSize" v-model="pageIndex" :total="totalRow" @change="pageChange"
					:hideOnSinglePage="true" show-less-items />
			</div>
		</a-card>
		
		<a-modal v-model="videoModalVisible" :width="720" :footer="null" :destroyOnClose="true"
			@cancel="closeVideoModal">
			<video ref="videoPlayer" controls :src="currentVideoUrl" height="400px" style="width: 100%;">
		
			</video>
		</a-modal>
	</div>
</template>

<script>
	import {
		callList
	} from "@/api/op/call";
	import moment from "moment/moment";

	const tableColumns = [{
			title: '#',
			dataIndex: 'id',
		},
		{
			title: '类型',
			scopedSlots: {
				customRender: 'type'
			}
		},
		{
			title: '主叫',
			scopedSlots: {
				customRender: 'caller'
			}
		},
		{
			title: '被叫',
			scopedSlots: {
				customRender: 'called'
			}
		},
        {
            title: '通话',
            scopedSlots: {
                customRender: 'chat'
            }
        },
        {
            title: '账单',
            scopedSlots: {
                customRender: 'bill'
            }
        },
		{
			title: '支出',
			scopedSlots: {
				customRender: 'expend'
			}
		},
        {
            title: '分润',
            scopedSlots: {
                customRender: 'income'
            }
        },
        {
            title: '风控',
            scopedSlots: {
                customRender: 'violation'
            }
        },
        {
            title: '结算',
            scopedSlots: {
                customRender: 'settle'
            }
        },
		{
			title: '创建时间',
			dataIndex: 'created'
		},
        {
            title: '操作',
            scopedSlots: {
                customRender: 'action'
            }
        }
	];

	export default {
		data() {
			return {
				advanced: false,
				queryParams: {},
				totalRow: 0,
				tableColumns,
				tableData: [],
				tableLoading: false,
				pageSize: 20,
				pageIndex: 1,
				isPlaying: false,
				createTime: [],

				currentPlaying: null, // 当前正在播放的录音ID
				audioPlayers: {}, // 存储audio实例
				
				videoModalVisible: false, // 控制视频弹窗的显示
				currentVideoUrl: '', // 当前要播放的视频URL
			}
		},
		created() {
			this.fetchTableData();
		},
		methods: {
			fetchTableData() {
				this.tableLoading = true;
				this.queryParams.pageSize = this.pageSize;
				this.queryParams.page = this.pageIndex;
				callList(this.queryParams).then(res => {
					this.totalRow = res.data.totalRow;
					this.tableData = res.data.recordList;
					this.tableLoading = false;
				});
			},
			toggleAdvanced() {
				this.advanced = !this.advanced;
			},
			onCreateTime(values) {
				this.queryParams.startCreateTime = moment(values[0]).unix();
				this.queryParams.endCreateTime = moment(values[1]).unix();
			},
			pageChange(current) {
				this.pageIndex = current;
				this.fetchTableData();
			},
			rest() {
				this.createTime = [];
				this.queryParams = {}
			},


			// 初始化audio播放器
			initAudioPlayer(record) {
				if (!this.audioPlayers[record.id]) {
					// 创建新的audio实例
					const audio = new Audio(record.tapeUrl);
					audio.preload = 'none';

					// 监听音频结束事件
					audio.addEventListener('ended', () => {
						this.currentPlaying = null;
					});

					// 存储audio实例
					this.audioPlayers[record.id] = audio;
				}

				return this.audioPlayers[record.id];
			},

			togglePlay(record) {
				// 如果点击的是当前正在播放的录音
				if (this.currentPlaying === record.id) {
					this.stopPlayback();
					return;
				}

				// 停止当前播放的录音（如果有）
				if (this.currentPlaying) {
					this.stopPlayback();
				}

				// 初始化并开始播放新录音
				const audioElement = this.initAudioPlayer(record);
				this.currentPlaying = record.id;
				audioElement.play().catch(error => {
					console.error('播放失败:', error);
					this.currentPlaying = null;
				});
			},

			stopPlayback() {
				if (this.currentPlaying && this.audioPlayers[this.currentPlaying]) {
					const audioElement = this.audioPlayers[this.currentPlaying];
					audioElement.pause();
					audioElement.currentTime = 0;
					this.currentPlaying = null;
				}
			},

			/**
			 * 打开视频弹窗并开始播放
			 * @param {string} videoUrl - 视频的URL
			 */
			openVideoModal(videoUrl) {
				this.currentVideoUrl = videoUrl;
				this.videoModalVisible = true; // 显示Modal

				// 在Modal显示后自动播放视频（注意浏览器自动播放策略）
				this.$nextTick(() => {
					const videoElem = this.$refs.videoPlayer;
					if (videoElem) {
						// 注意：许多浏览器要求带有声音的媒体必须由用户交互（如点击）后才能自动播放。
						// 可以尝试静音后播放，或者等待用户点击video自带的控制条播放按钮。
						videoElem.play().catch(error => {
							console.error('自动播放失败:', error);
							// 处理自动播放被阻止的情况，例如提示用户手动点击播放
						});
					}
				});
			},

			/**
			 * 关闭视频弹窗并暂停播放
			 */
			closeVideoModal() {
				this.videoModalVisible = false;
				const videoElem = this.$refs.videoPlayer;
				if (videoElem) {
					videoElem.pause(); // 暂停视频播放[6](@ref)
					// videoElem.currentTime = 0; // 可选：将进度重置到开头
				}
			},
		},
		beforeDestroy() {
			// 组件销毁前停止所有播放并清理资源
			this.stopPlayback();

			// 移除所有audio实例
			Object.values(this.audioPlayers).forEach(audio => {
				audio.pause();
				audio.src = '';
				audio.load();
			});

			this.audioPlayers = {};
		}
	}
</script>

<style lang="less" scoped>
	.user {
		display: flex;
		flex-direction: row;

		.user-left {
			display: flex;
			flex-direction: column;
			margin-right: 8px;
			text-align: center;

			.cover-img {
				border-radius: 4px;
				object-fit: cover;
			}
		}

		.user-right {
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			p.first {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				align-items: center;
				margin: 0;

				.nickname {
					color: #686868;
					font-weight: bold;
				}

				.user-id {
					font-size: 12px;
					color: #acacac;
				}
			}

			p.row {
				font-size: 12px;
				color: #acacac;
				margin: 0;
			}

			.user-right-detail {
				margin-right: 5px;
			}
		}
	}

	.user-empty {
		color: #acacac;
		font-size: 12px;
	}

	.complex {
		display: flex;
		flex-direction: column;
	}

    .depict {
        margin: 0;
        font-size: 12px;
        color: #ccc;
    }

	a.playing {
		color: #f5222d;
	}

	.price-span {
		font-size: 12px;
		color: #ccc;
	}

	.play-audio, .video-thumbnail {
		margin-left: 5px;
	}

	.calling-span {
		font-size: 12px;
		color: #f59a23;
	}

	.rate {
        font-size: 12px;
		color: #ccc;
	}

	.assist {
		font-size: 12px;
        color: #acacac;
	}
</style>